var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAutopilotElectric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_549_416)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3833 5.42222C14.4964 5.69593 14.5401 6.01474 14.5401 6.34661V10.4799H15.9335C16.4827 10.4799 17.1441 10.6475 17.4161 11.2497C17.6881 11.8521 17.3758 12.4581 17.0132 12.8679C17.013 12.8681 17.0127 12.8684 17.0125 12.8686L11.9672 18.6004C11.748 18.8493 11.5044 19.0597 11.2391 19.1905C10.9709 19.3228 10.6286 19.396 10.2817 19.2657C9.93438 19.1354 9.72479 18.8546 9.61035 18.5777C9.49725 18.3039 9.45347 17.9851 9.45347 17.6533V13.5199H8.06014C7.5148 13.5199 6.85526 13.3543 6.58293 12.7535C6.31127 12.1541 6.61896 11.5484 6.97666 11.1363L6.97971 11.1328L12.0264 5.39946C12.2456 5.15058 12.4892 4.94021 12.7545 4.80933C13.0227 4.67706 13.365 4.6039 13.712 4.73414C14.0592 4.86452 14.2688 5.14528 14.3833 5.42222ZM13.027 6.28063L7.98222 12.0119C7.92721 12.0754 7.88942 12.129 7.86378 12.1718C7.91243 12.1802 7.97702 12.1866 8.06014 12.1866H10.1201C10.4883 12.1866 10.7868 12.4851 10.7868 12.8533V17.6533C10.7868 17.7452 10.792 17.8228 10.8003 17.8871C10.8495 17.8441 10.9051 17.789 10.9664 17.7195L16.0131 11.9861L16.0144 11.9846C16.0691 11.9228 16.107 11.8704 16.1329 11.8285C16.0835 11.8199 16.018 11.8133 15.9335 11.8133H13.8735C13.5053 11.8133 13.2068 11.5148 13.2068 11.1466V6.34661C13.2068 6.25469 13.2016 6.17706 13.1933 6.11273C13.1441 6.15578 13.0884 6.21103 13.027 6.28063Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutopilotElectric);
export default __webpack_public_path__ + "static/media/autopilotElectric.a72ede88.svg";
export { ForwardRef as ReactComponent };